/** Remove signed preference-link identity from logs, monitoring, and error sinks. */
export function safeCurrentUrl(): string {
  if (typeof window === "undefined") return "";
  if (window.location.pathname.startsWith("/email-preferences/")) {
    return `${window.location.origin}${window.location.pathname}`;
  }
  return window.location.href;
}
